import { render } from "./NotFound.vue?vue&type=template&id=6923dcae"
const script = {}

import exportComponent from "/Users/andrew/Work/Projects/Pocketkey/qrdynamic/qrdynamic-admin/qrdynamic-admin-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__